import React, { FC } from 'react';
import { View } from 'react-native';
import HeaderTwo from '../HeaderTwo';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import styles from './styles';
import dayjs from 'dayjs';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { green, red, iconGrey } from '../../../constants/palette';

export type FeedbackCardProps = {
  feedback: any[];
};

export const FeedbackCard: FC<FeedbackCardProps> = ({ feedback }) => {
  const feedbackTitle = feedback.length > 0 ? 'Feedback' : 'No feedback yet';

  const getLikeIcon = (likeValue) => {
    let name, color;
    if (likeValue === 0) return null;
    if (likeValue === 1) {
      name = 'thumb-up-outline';
      color = green;
    } else {
      name = 'thumb-down-outline';
      color = red;
    }
    return <MaterialCommunityIcons name={name} size={20} color={color} />;
  };

  return (
    <View style={styles.baseContainer}>
      <HeaderTwo title={feedbackTitle} />
      <View style={styles.feedbackCardContainer}>
        {feedback.length > 0 &&
          feedback.map((feedbackItem) => (
            <View key={feedbackItem.id} style={styles.container}>
              <View style={styles.iconWrapper}>
                <GalanoGrotesqueText>
                  <GalanoGrotesqueText style={styles.rowTitle}>
                    Fan Name:{' '}
                  </GalanoGrotesqueText>
                  {feedbackItem.fan.fullName}
                </GalanoGrotesqueText>
                <View>{getLikeIcon(feedbackItem.likeValue)}</View>
              </View>
              <GalanoGrotesqueText>
                <GalanoGrotesqueText style={styles.rowTitle}>
                  Date:{' '}
                </GalanoGrotesqueText>
                {dayjs(feedbackItem.createdAt).format('MMM DD, YYYY @ hh:mma')}
              </GalanoGrotesqueText>
              <GalanoGrotesqueText style={styles.rowTitle}>
                Comment:
              </GalanoGrotesqueText>
              <GalanoGrotesqueText style={styles.commentText}>
                {feedbackItem.comment}
              </GalanoGrotesqueText>
            </View>
          ))}
      </View>
    </View>
  );
};
